import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0001 16.6667C13.682 16.6667 16.6667 13.6819 16.6667 9.99999C16.6667 6.31809 13.682 3.33332 10.0001 3.33332V16.6667ZM18.3334 9.99999C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C9.68776 18.3333 9.37914 18.3161 9.07519 18.2825C4.90768 17.8218 1.66675 14.29 1.66675 9.99999C1.66675 5.71003 4.90768 2.17817 9.07519 1.71747C9.37914 1.68387 9.68776 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 9.99999Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }